"use strict";
// write code here
"use strict";
var table = document.querySelector("table");
var appendRowButton = document.querySelector(".append-row");
var removeRowButton = document.querySelector(".remove-row");
var appendColumnButton = document.querySelector(".append-column");
var removeColumnButton = document.querySelector(".remove-column");
var MIN_SIZE = 2;
var MAX_SIZE = 10;
function getRowsCount() {
    return table.rows.length;
}
function getColumnsCount() {
    return table.rows[0].cells.length;
}
function updateButtons() {
    var rowsCount = getRowsCount();
    var columnsCount = getColumnsCount();
    appendRowButton.disabled = rowsCount >= MAX_SIZE;
    removeRowButton.disabled = rowsCount <= MIN_SIZE;
    appendColumnButton.disabled = columnsCount >= MAX_SIZE;
    removeColumnButton.disabled = columnsCount <= MIN_SIZE;
}
appendRowButton.addEventListener("click", function() {
    if (getRowsCount() >= MAX_SIZE) return;
    var columnsCount = getColumnsCount();
    var row = table.insertRow();
    for(var i = 0; i < columnsCount; i++)row.insertCell();
    updateButtons();
});
removeRowButton.addEventListener("click", function() {
    if (getRowsCount() <= MIN_SIZE) return;
    table.deleteRow(getRowsCount() - 1);
    updateButtons();
});
appendColumnButton.addEventListener("click", function() {
    if (getColumnsCount() >= MAX_SIZE) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = table.rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var row = _step.value;
            row.insertCell();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    updateButtons();
});
removeColumnButton.addEventListener("click", function() {
    if (getColumnsCount() <= MIN_SIZE) return;
    var lastColumnIndex = getColumnsCount() - 1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = table.rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var row = _step.value;
            row.deleteCell(lastColumnIndex);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    updateButtons();
});
updateButtons();

//# sourceMappingURL=index.7ab4dbfc.js.map
